import redirectTo from '@99designs/apps/spa/common/Ssr/redirectTo';
import { linkTo } from '@99designs/routing';

type BriefWithForeignKeys = { foreignKeys: number[] };
type BriefWithProjectKeys = { projectIds: number[] };
type Brief = BriefWithForeignKeys | BriefWithProjectKeys;

function isBriefWithForeignKeys(kind: Brief): kind is BriefWithForeignKeys {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (kind as any).foreignKeys !== undefined;
}

function isBriefWithProjectKeys(kind: Brief): kind is BriefWithProjectKeys {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (kind as any).projectIds !== undefined;
}

export function launchedBriefUrl(brief: Brief) {
    // eslint-disable-next-line eqeqeq
    if (isBriefWithForeignKeys(brief) && brief.foreignKeys.length == 1) {
        return linkTo.project(`${brief.foreignKeys[0]}`);
        // eslint-disable-next-line eqeqeq
    } else if (isBriefWithProjectKeys(brief) && brief.projectIds.length == 1) {
        return linkTo.project(`${brief.projectIds[0]}`);
    } else {
        return linkTo.yourWork();
    }
}

export const redirectLaunchedBrief = (brief: Brief) => {
    return redirectTo(launchedBriefUrl(brief));
};

export const redirectLaunchedStructuredBrief = (brief: Brief) => {
    return redirectTo(launchedBriefUrl(brief));
};
